import { RegMenReportsService } from "~/entity/RegMenReports/api/service";

import { useRegMenReportMutation } from "./useRegMenReportMutation";

export const useGetRegMenByPeriodReport = () => {
  const { data, isLoading, isError, mutate, reset } = useRegMenReportMutation(
    RegMenReportsService.GET.getRegMenByDealerByPeriod,
  );

  return {
    data,
    isLoading,
    isError,
    getRegMenByPeriodReport: mutate,
    resetRegMenByPeriodReport: reset,
  };
};
